import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import IconButton from "@mui/material/IconButton";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GET_ANON_PROTOCOLS } from "../../../src/appConstants";
import "../../components/Headers/Header.css";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import DeleteAlert from "../DeleteAlert";

import Table from "../ConfigurePages/Table";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";
import AddCutomProtocol from "../Modal/AddCutomProtocol";
import AddProtocolModal from "../Modal/AddProtocolModal";
import "../Modal/Modal.css";
import SideBar from "../SideBar/SideBar";
import "../Tables/Table.css";
import LoaderComponent from "./LoaderComponent/LoaderComponent";

const AnonProtocolTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setloader] = useState(true);
  const [Addcustomdata, setAddcustomdata] = useState(false);
  const [modal, setModal] = useState(false);
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rules, setrules] = useState();
  const [add, setAdd] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteID, setDeleteID] = useState(0);
  const [deleteUpdate, setdeleteUpdate] = useState(false);

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 15,
    },
  }));

  const handleDelete = (id) => {
    setDeleteAlert(true);
    setDeleteID(id);
  };

  const handleEdit = (data) => {
    setAdd(true);
    setEditData(data);
  };

  const handleModalOpen = () => {
    setModal(true);
  };

  const handleModalClose = () => {
    setAddcustomdata(false);
    setModal(false);
    setEditData({});
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };

  const handleclick = () => {
    setAdd(true);
    setEditData({});
  };
  const handleclickcustom = () => {
    setAdd(false);
    setAddcustomdata(true);
  };
  const handleModalClosee = () => {
    setAdd(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_ANON_PROTOCOLS}?page=${count}&size=10`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setData(response.data.items);
        setTotalPages(response.data.pages);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };

    fetchData();
  }, [count, update, deleteUpdate]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated !== "true") {
      navigate("/login");
    }
  });

  return (
    <div className="d-flex min-vh-100  background">
      <SideBar />
      <div>
        <HomeHeader />
        <div className="d-flex flex-column">
          <div className="header">
            <div className="header-text  d-flex justify-content-between">
              <div>ANONYMIZATION PROTOCOL</div>
              <div>
                <button
                  type="button"
                  className="btn  mr-4 shadow  btn-dataset"
                  style={{
                    height: "39px",
                    width: "200px",
                    color: "black",
                    backgroundColor: "rgb(15, 196, 160)",
                    top: "28px",
                    fontWeight: "bold",
                    cursor: " pointer",
                    font: "Montserrat",
                  }}
                  onClick={handleclick}
                >
                  ADD
                </button>
              </div>
            </div>
          </div>

          {loader ? (
            <div>
              <table className="styled-table">
                <thead>
                  <tr>
                    {/* <th>SR.No.</th> */}
                    <th>Name</th>
                    <th>Rules</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length && data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        {/* <td>{index + 1 + (count - 1) * 10}</td> */}
                        <td>{item.name}</td>
                        <td>
                          <i
                            className="fa fa-eye"
                            onClick={() => {
                              handleModalOpen();
                              setrules(item.rules);
                            }}
                          ></i>
                        </td>
                        <td>
                          <BootstrapTooltip title="Delete">
                            <IconButton>
                              <DeleteIcon
                                onClick={() => handleDelete(item.id)}
                                style={{
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                          {deleteAlert && (
                            <DeleteAlert
                              type="AnonymizationProtocolTable"
                              id={deleteID}
                              deleteAlert={deleteAlert}
                              setDeleteAlert={setDeleteAlert}
                              handlePage={handlePageChange}
                              count={count}
                              data={data}
                              setdeleteUpdate={setdeleteUpdate}
                            />
                          )}
                          &nbsp;
                          <BootstrapTooltip title="Edit">
                            <IconButton>
                              <ModeEditIcon
                                onClick={() => handleEdit(item)}
                                style={{
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center font-weight-bold">
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {data && data.length > 0 && (
                <div className="d-flex justify-content-end pb-5">
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages && totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    forcePage={count && count - 1} //{entityList.number}
                    onPageChange={(e) => handlePageChange(e.selected)}
                    containerClassName="pagination"
                    subContainerClassName="pages pagination"
                    activeClassName="active"
                    previousLinkClassName="pagination-link"
                    nextLinkClassName="pagination-link"
                    breakLinkClassName="pagination-link"
                    pageLinkClassName="pagination-link"
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ margin: "10vw 48vw" }}
            >
              <div>
                <LoaderComponent />
              </div>
            </div>
          )}
        </div>
      </div>
      {add && (
        <AddProtocolModal
          ModalState={add}
          handleClose={handleModalClosee}
          setUpdate={setUpdate}
          editData={editData}
          handleclickcustom={handleclickcustom}
        />
      )}
      {modal && (
        <Table modal={modal} handleClose={handleModalClose} rules={rules} />
      )}
      {Addcustomdata && (
        <AddCutomProtocol
          handleClose={handleModalClose}
          ModalState={setAddcustomdata}
        />
      )}
    </div>
  );
};

export default AnonProtocolTable;
